import BLOG_CATEGORIES from "./blogCategories";

export default function CategorySection({
  formData,
  errors,
  refs,
  setFormData,
}) {

  // ================= ALL SUBCATEGORIES =================
  const allSubCategories = BLOG_CATEGORIES.flatMap((cat) =>
    cat.subcategories.map((sub) => ({
      name: sub.name,
      category: cat.category,
      tags: sub.tags || [],
    }))
  );

  // ================= ALL TAGS =================
  const allTags = BLOG_CATEGORIES.flatMap((cat) =>
    cat.subcategories.flatMap((sub) =>
      sub.tags?.map((tag) => ({
        tag,
        subCategory: sub.name,
        category: cat.category,
      }))
    )
  );

  // ================= CATEGORY CHANGE =================
  const handleCategoryChange = (e) => {
    const category = e.target.value;

    setFormData({
      ...formData,
      Category: category,
      SubCategory: "",
      Tags: "",
    });
  };

  // ================= SUBCATEGORY CHANGE =================
  const handleSubCategoryChange = (e) => {
    const subName = e.target.value;

    const found = allSubCategories.find((s) => s.name === subName);

    setFormData({
      ...formData,
      Category: found?.category || "",
      SubCategory: subName,
      Tags: "",
    });
  };

  // ================= TAG CHANGE =================
  const handleTagChange = (e) => {
    const tag = e.target.value;

    const found = allTags.find((t) => t.tag === tag);

    setFormData({
      ...formData,
      Category: found?.category || "",
      SubCategory: found?.subCategory || "",
      Tags: tag,
    });
  };

  // ================= FILTERED SUBCATEGORIES =================
  const filteredSubCategories = formData.Category
    ? allSubCategories.filter((s) => s.category === formData.Category)
    : allSubCategories;

  // ================= FILTERED TAGS =================
  const filteredTags = formData.SubCategory
    ? allTags.filter((t) => t.subCategory === formData.SubCategory)
    : allTags;

  return (
    <div className="mb-6 space-y-6">

      {/* CATEGORY */}
      <div>
        <label className="block mb-2 font-semibold">Category</label>

        <select
          ref={refs.Category}
          value={formData.Category}
          onChange={handleCategoryChange}
          className="border p-3 w-full"
        >
          <option value="">Select Category</option>

          {BLOG_CATEGORIES.map((c) => (
            <option key={c.category} value={c.category}>
              {c.category}
            </option>
          ))}
        </select>

        {errors.Category && (
          <p className="text-red-600">{errors.Category}</p>
        )}
      </div>


      {/* SUBCATEGORY */}
      <div>
        <label className="block mb-2 font-semibold">Sub Category</label>

        <select
          ref={refs.SubCategory}
          value={formData.SubCategory}
          onChange={handleSubCategoryChange}
          className="border p-3 w-full"
        >
          <option value="">Select Sub Category</option>

          {filteredSubCategories.map((s) => (
            <option key={s.name} value={s.name}>
              {s.name} 
            </option>
          ))}
        </select>

        {errors.SubCategory && (
          <p className="text-red-600">{errors.SubCategory}</p>
        )}
      </div>


      {/* TAGS */}
      <div>
        <label className="block mb-2 font-semibold">Tags</label>

        <select
          ref={refs.Tags}
          value={formData.Tags}
          onChange={handleTagChange}
          className="border p-3 w-full"
        >
          <option value="">Select Tag</option>

          {filteredTags.map((t) => (
            <option key={t.tag} value={t.tag}>
              {t.tag} 
            </option>
          ))}
        </select>

        {errors.Tags && (
          <p className="text-red-600">{errors.Tags}</p>
        )}
      </div>

    </div>
  );
}





















// import BLOG_CATEGORIES from "./blogCategories";

// export default function CategorySection({
//   formData,
//   errors,
//   refs,
//   setFormData,
// }) {
//   const selectedCategory = BLOG_CATEGORIES.find(
//     (c) => c.category === formData.Category
//   );

//   return (
//     <div className="mb-6 space-y-6">
//       {/* CATEGORY */}
//       <div>
//         <label className="block mb-2 font-semibold">Category</label>
//         <select
//           ref={refs.Category}
//           value={formData.Category}
//           onChange={(e) =>
//             setFormData({
//               ...formData,
//               Category: e.target.value,
//               SubCategory: "",
//             })
//           }
//           className="border p-3 w-full"
//         >
//           <option value="">Select Category</option>
//           {BLOG_CATEGORIES.map((c) => (
//             <option key={c.category} value={c.category}>
//               {c.category}
//             </option>
//           ))}
//         </select>
//         {errors.Category && <p className="text-red-600">{errors.Category}</p>}
//       </div>

//       {/* SUB CATEGORY */}
//       <div>
//         <label className="block mb-2 font-semibold">Sub Category</label>
//         <select
//           ref={refs.SubCategory}
//           value={formData.SubCategory}
//           disabled={!formData.Category}
//           onChange={(e) =>
//             setFormData({
//               ...formData,
//               SubCategory: e.target.value,
//             })
//           }
//           className="border p-3 w-full"
//         >
//           <option value="">Select Sub Category</option>
//           {selectedCategory?.subcategories.map((s) => (
//             <option key={s.name} value={s.name}>
//               {s.name}
//             </option>
//           ))}
//         </select>
//         {errors.SubCategory && (
//           <p className="text-red-600">{errors.SubCategory}</p>
//         )}
//       </div>
//     </div>
//   );
// }